import { html } from 'lit';
import { get } from 'lodash';
import { AdditionalRowRenderer, FlexibleTableDisplayColumn, FlexibleTableRow } from './models';

export class FlexibleTableDataSource<T> {
  public rows: Array<FlexibleTableRow> = [];

  public requestUpdate: () => void;

  public additionalRowRenderer: AdditionalRowRenderer = () => html``;

  public setRowClasses: (rowData: T) => string;

  constructor(public data: Array<T>) {}

  public setDisplayColumns(flexibleTableColumn: Array<FlexibleTableDisplayColumn>) {
    this.rows = this.data.map((element, rowIndex) => ({
      columns: flexibleTableColumn.map((column, columnIndex) => {
        return {
          value: get(element, column.getRenderPath()),
          sideHeader: column.getSideHeader(),
          cellRenderer: column.getCellRenderer() && column.getCellRenderer().bind(null, element, rowIndex, columnIndex),
          flex: column.getFlex(),
        };
      }),
    }));
  }

  public setAdditionalRowRenderer(additionalRowRenderer: AdditionalRowRenderer): void {
    this.additionalRowRenderer = additionalRowRenderer;
  }
}
